var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5729 7.42686C13.4579 4.73771 10.8218 3 7.85714 3C4.89245 3 2.25634 4.73771 1.14143 7.42686C0.952855 7.88171 0.952855 8.40343 1.14143 8.85886C2.25634 11.548 4.89245 13.2857 7.85714 13.2857C10.8218 13.2857 13.4579 11.548 14.5729 8.85886C14.7614 8.404 14.7614 7.88171 14.5729 7.42686ZM7.85714 10.4286C6.59652 10.4286 5.57133 9.40343 5.57133 8.14286C5.57133 6.88229 6.59652 5.85714 7.85714 5.85714C9.11777 5.85714 10.143 6.88229 10.143 8.14286C10.143 9.40343 9.11777 10.4286 7.85714 10.4286Z",
    fill: "url(#paint0_linear_1268_8832)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1268_8832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5729 6.42686C14.4579 3.73771 11.8218 2 8.85714 2C5.89245 2 3.25634 3.73771 2.14143 6.42686C1.95286 6.88171 1.95286 7.40343 2.14143 7.85886C3.25634 10.548 5.89245 12.2857 8.85714 12.2857C11.8218 12.2857 14.4579 10.548 15.5729 7.85886C15.7614 7.404 15.7614 6.88171 15.5729 6.42686ZM8.85714 9.42857C7.59652 9.42857 6.57133 8.40343 6.57133 7.14286C6.57133 5.88229 7.59652 4.85714 8.85714 4.85714C10.1178 4.85714 11.143 5.88229 11.143 7.14286C11.143 8.40343 10.1178 9.42857 8.85714 9.42857Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1268_8832",
    x: -0.3,
    y: -0.3,
    width: 18.3144,
    height: 14.8852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1268_8832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1268_8832",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1268_8832",
    x1: 13.5,
    y1: 2,
    x2: 4,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitors);
export default __webpack_public_path__ + "static/media/visitors.e8becd25bb529f7bd7394b2c6b4f242a.svg";
export { ForwardRef as ReactComponent };